import { render, staticRenderFns } from "./NetPaTab.vue?vue&type=template&id=5f2ff940&scoped=true&"
import script from "./NetPaTab.vue?vue&type=script&lang=js&"
export * from "./NetPaTab.vue?vue&type=script&lang=js&"
import style0 from "./NetPaTab.vue?vue&type=style&index=0&id=5f2ff940&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f2ff940",
  null
  
)

export default component.exports